<template>
  <el-select v-model="selected" filterable multiple v-bind="$attrs" @change="change">
    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selected: [],
      options: []
    }
  },
  watch: {
    value (val) {
      this.selected = val
    }
  },
  created () {
    this.$store.dispatch('fetchPeople').then(people => {
      this.options = people
    })
  },
  methods: {
    change (val) {
      this.$emit('input', val)
    }
  }
}
</script>
